import Honeybadger from 'honeybadger-js'

const config = {
  api_key: process.env.REACT_APP_HONEYBADGER_KEY
    ? process.env.REACT_APP_HONEYBADGER_KEY
    : '',
  environment: process.env.REACT_APP_STAGE
    ? process.env.REACT_APP_STAGE
    : 'development',
  revision: process.env.REACT_APP_COMMIT_SHA,
}

const HoneybadgerConfig = Honeybadger.configure(config)

Honeybadger.beforeNotify(notice => {
  const url = notice?.url || notice.context?.url || ''
  const message = notice.message || notice.errors?.[0]?.message || ''

  if (notice.environment === 'development') {
    return false
  }

  // SVGAnimatedString (SVG elements from charts) doesn't have .trim() —
  // this is a Honeybadger internals limitation, not an app error.
  if (message.includes('className.trim is not a function')) {
    return false
  }

  // "Converting circular structure to JSON" envolvendo o fiber interno do
  // React (__reactFiber$...): o backtrace real mostra frames <anonymous> sem
  // URL de origem chamando um "HTMLDivElement.appendChild" com trace
  // próprio — sinal de que alguma extensão do navegador sobrescreveu o
  // appendChild nativo pra inspecionar elementos inseridos na página, e
  // quebra ao tentar serializar um nó que já carrega essa referência
  // circular do React. Não é código nosso, não é acionável.
  if (
    message.includes('Converting circular structure to JSON') &&
    message.includes('__reactFiber$')
  ) {
    return false
  }

  // Chunk JS desatualizado após deploy: o browser busca um bundle com hash
  // antigo, o fallback SPA devolve index.html no lugar do JS, e o parse da
  // resposta como script estoura esse SyntaxError. Já é tratado com reload
  // automático em staleChunkReload.js — não é acionável aqui.
  if (message.includes("Unexpected token '<'")) {
    return false
  }

  // Ignora erros de sessão expirada (401)
  if (url.includes('/session/destroy') || url.includes('/session/new')) {
    return false
  }

  //Ignora os erros de relatório compartilhado desatualizado
  if (url.includes('/share/') && message.includes('422')) {
    return false
  }

  // Ignora 404 em telas de compartilhamento: acontece quando o token do
  // link expirou, é o resultado esperado (não um bug).
  if (url.includes('/share/') && message.includes('404')) {
    return false
  }

  // Falhas de rede sem detalhe do motivo (o browser não expõe se foi DNS,
  // CORS ou conexão caindo). Se o navegador se dizia offline, é bem provável
  // que seja mesmo a internet do usuário — não acionável, ignora. Se dizia
  // online, o problema é mais provável no servidor/CORS/DNS, então deixa
  // passar para investigação, com o estado do navigator anexado ao contexto.
  if (message.includes('Network Error')) {
    if (!navigator.onLine) {
      return false
    }

    notice.context = {
      ...notice.context,
      navigatorOnLine: navigator.onLine,
    }
  }

  // Captura informações extras para o erro de pathname
  if (
    notice.message?.includes(
      "Cannot read properties of undefined (reading 'pathname')"
    )
  ) {
    const userInfo = getUserInfoFromStorage()

    notice.context = {
      ...notice.context,
      user: userInfo,
    }
  }
})

const getUserInfoFromStorage = () => {
  try {
    const tokenString = localStorage.getItem('token')
    if (!tokenString) return null

    const token = JSON.parse(tokenString)
    if (!token?.jwt) return null

    const payload = JSON.parse(window.atob(token.jwt.split('.')[1]))

    return {
      sub: payload.user_id || payload.sub || payload.id,
      email: payload.email,
      roles: payload.roles,
    }
  } catch (error) {
    return { error: 'Failed to parse token from localStorage' }
  }
}

export default HoneybadgerConfig
